import React, { useCallback, useEffect, useState } from "react"

import { Error } from "@/components/error"
import { baseUrl } from "@/constants"
import { File } from "@/models"

import { BeforeUpload } from "./before-upload"
import { Uploading } from "./uploading"

type UploadProps = {
  file: File | undefined
  isUploading: boolean
  successfullySubmittedToBackend: boolean
  redirect: string
  path: "upload-front" | "upload-back" | "upload"
  upload: (redirect: string) => void
}

export const Upload: React.FC<UploadProps> = ({
  file,
  isUploading,
  successfullySubmittedToBackend,
  redirect,
  path,
  upload,
}) => {
  const [previewImgURL, setPreviewImgURL] = useState<string>("")
  const [isPDF, setIsPDF] = useState<boolean>(false)

  const onSubmitClick = useCallback(() => upload(redirect), [redirect])

  useEffect(() => {
    if (file) {
      if (file.type === "application/pdf") {
        setIsPDF(true)
        upload(redirect)
      }

      setPreviewImgURL(URL.createObjectURL(file))
    }
  }, [file])

  if (!previewImgURL) return <Error cancelUrl={`${baseUrl}/proofOfIdentity`} />

  if (isUploading || successfullySubmittedToBackend)
    return <Uploading alt={file?.name} imgUrl={previewImgURL} isPDF={isPDF} shouldRedirectToMainPage={!redirect.includes("flip-your-card")} isUploading={isUploading} successfullySubmittedToBackend={successfullySubmittedToBackend}/>

  return (
    <BeforeUpload
      alt={file?.name}
      imgUrl={previewImgURL}
      isPDF={isPDF}
      path={path}
      onClick={onSubmitClick}
    />
  )
}
